import { render, staticRenderFns } from "./StoryItem.vue?vue&type=template&id=e8a64a70&scoped=true&"
import script from "./StoryItem.vue?vue&type=script&lang=js&"
export * from "./StoryItem.vue?vue&type=script&lang=js&"
import style0 from "./StoryItem.vue?vue&type=style&index=0&id=e8a64a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a64a70",
  null
  
)

export default component.exports